import React, { useCallback, useEffect, useState } from "react";

import Table from "../components/table/Table";
import MenuOptions from "../components/threeDots/Menu";

import config from "../api/config";
import "../assets/css/customers.css";

import Editingmessage from "../components/EditingMessage";
import { Snackbar } from "@mui/material";
import Alert from "../components/alert";
import { useDispatch, useSelector } from "react-redux";
import { setToast } from "../redux/actions/ToastAction";

const MessagesController = () => {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [currpage, setCurrPage] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // modal
  const [modal, setModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  // snackbar
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  // search user
  const searchHandler = (e) => {
    setSearch(e.target.value);
    setLoading(true);
    config
      .get(`/api/message/v1?search=${e.target.value}`)
      .then((data) => {
        setLoading(false);

        setUsers(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });
  };

  // change pages
  const pageHandler = useCallback((page) => {
    setLoading(true);
    setPage(page);
    config
      .get(`/api/message/v1?page=${page}`)
      .then((data) => {
        setLoading(false);

        setUsers(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });

  }, []);

  // get data
  useEffect(() => {
    pageHandler(0);
  }, [pageHandler]);

  // save edited user
  const saveHandler = async (bool, object) => {
    if (bool) {
      try {
        await config.post(`/api/message/v1`, object);
        dispatch(setToast(true, "success", "Успешно Изменено"));
        setModal(false);
        pageHandler(page);
      } catch (e) {
        console.error(e?.message);
      }
    }
  };

  // table data
  const headData = ["Description", "Russian Message"];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item, index, func) => (
    <tr key={index}>
      <td style={{ width: "35%" }}>{item.description}</td>
      <td style={{ width: "60%" }}> {item.textRu}</td>
      <td>
        <MenuOptions
          options={[
            {
              value: "Изменять",
              callback: () => {
                setEditUser(item);
                setModal(true);
              },
            },
            {
              value: "Удалить",
              callback: () => {
                // setDeleteID(item.id);
                // setModal(true);
              },
            },
          ]}
        />
      </td>
    </tr>
  );

  return (
    <div>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      <Editingmessage
        message={editUser}
        _callback={saveHandler}
        modal={modal}
        setModal={() => setModal(!modal)}
      />
      <h2 className="page-header">Messages</h2>
      <div className="row pb-5">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <input type="text" value={search} onChange={searchHandler} />
            </div>
          </div>

          <Table
            headData={headData}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={users}
            renderBody={(item, index) => renderBody(item, index)}
            pages={total}
            currPage={currpage}
            changePage={pageHandler}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default MessagesController;
